'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var requiredKeys = ['authType', 'rootUrl', 'tracker', 'blockingRequests', 'getMerchandiseCatalog', 'defaultHubRoute'];

//const exampleInterface = {
//  // Env-specific data
//  getLang: () => { ... },
//  getPurchaseMotions: () => { ... }
//  tracker: _PublicUsageTracker(),
//
//  // Env-specific business rules
//  allowTrials: false,
//  allowInlineChat: true,
//  allowMultiCurrency: true,
//  allowMon256Experiment: false,
//}

// Validates that a config has all the required keys

exports.default = function (config) {
  requiredKeys.forEach(function (key) {
    if (config[key] === undefined) {
      throw new Error('config is missing ' + key);
    }
  });

  return config;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/createConfigInterface.js
// module id = 791
// module chunks = 3 4